var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTable = function SvgTable(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.5v-.833c-.46 0-.833.373-.833.833h.833zm0 15h-.833c0 .46.373.833.833.833v-.833zm15-15h.833c0-.46-.373-.833-.833-.833v.833zm0 15v.833c.46 0 .833-.373.833-.833h-.833zm-15.833-15v15h1.667v-15h-1.667zm.833 15.833h5v-1.667h-5v1.667zm5-16.667h-5v1.667h5v-1.667zm0 1.667h10v-1.667h-10v1.667zm9.167-.833v5.833h1.667v-5.833h-1.667zm-8.333 15v-9.167h-1.667v9.167h1.667zm0-9.167v-5.833h-1.667v5.833h1.667zm4.167 8.333h-5v1.667h5v-1.667zm0 1.667h5v-1.667h-5v1.667zm5.833-.833v-9.167h-1.667v9.167h1.667zm-10.833-8.333h10v-1.667h-10v1.667z",
    fill: "#fff"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTable, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/table.b604a607.svg";
export { ForwardRef as ReactComponent };